import React, { FC } from "react";

import Modal from "../../../../atoms/ActiveLearning/Modal";
import { ReactComponent as CloseIcon } from "../../../../assets/images/ActiveLearning/icon_close.svg";

import styles from "./InquiryEvaluationCriteriaModal.module.scss";

type Props = {
  onClose: () => void;
};

const CRITERIA_SECTIONS = [
  {
    title: "1. 興味・関心から生まれた問いか（内発性）",
    rows: [
      {
        no: "3",
        text:
          "問いが自分の具体的な経験・違和感・価値観と明確に結びついている。「なぜそれが気になるのか」が説明されている。",
      },
      {
        no: "2",
        text:
          "興味・関心との関連は読み取れるが、理由や背景の記述が十分ではない。",
      },
      {
        no: "1",
        text: "問いと本人の興味・関心のつながりが読み取れない。",
      },
    ],
  },
  {
    title: "2. 正解のない問いになっているか（思考の深さ）",
    rows: [
      {
        no: "3",
        text:
          "調べるだけでは答えが出ず、原因・背景・関係性を分析し、自分なりの答えを考える必要がある問い。",
      },
      {
        no: "2",
        text: "既存の情報を整理・比較することで一定の答えに近づく問い。",
      },
      {
        no: "1",
        text: "調べれば明確な答えが出る問い、または二者択一で終わる問い。",
      },
    ],
  },
  {
    title: "3. 具体的に考えられているか（具体性）",
    rows: [
      {
        no: "3",
        text:
          "対象、場所・地域、時間軸、条件・制約、アプローチ・手法などの観点で3つ以上の絞り込みがある。",
      },
      {
        no: "2",
        text:
          "対象、場所・地域、時間軸、条件・制約、アプローチ・手法などの観点で、2つ絞り込みがある。",
      },
      {
        no: "1",
        text: "対象が1つ、もしくは絞り込めていない。",
      },
    ],
  },
];

export const InquiryEvaluationCriteriaModal: FC<Props> = ({ onClose }) => {
  return (
    <Modal handleClose={onClose}>
      <div className={styles.wrapper}>
        <button className={styles.closeButton} onClick={onClose} type="button">
          <CloseIcon />
        </button>
        <div className={styles.container}>
          <p className={styles.title}>「課題の設定」を評価する３つの観点</p>
          <p className={styles.description}>
            エナジードは、「フレームワークではなく、生徒一人ひとりの内側から生まれる問い」を起点とした探究を大切にしています。
            <br />
            そのため、問いの評価においても、内発性・思考の深さ・具体性の3つの観点を重視しています。
            <br />
            自分の興味・関心から生まれた問いであるか（内発性）、調べるだけでは終わらず自分なりに考える余地があるか（思考の深さ）、そして実際に探究を進められるレベルまで具体化されているか（具体性）。
            <br />
            これらを可視化することで、生徒の思考をより深く、より実践的な探究へと導きます。
          </p>
          <div className={styles.sections}>
            {CRITERIA_SECTIONS.map(section => (
              <section className={styles.section} key={section.title}>
                <p className={styles.sectionTitle}>{section.title}</p>
                <table className={styles.criteriaTable}>
                  <tbody>
                    {section.rows.map(row => (
                      <tr key={`${section.title}-${row.no}`}>
                        <th>{row.no}</th>
                        <td>{row.text}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </section>
            ))}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default InquiryEvaluationCriteriaModal;
